<template>
    <div class="information">
        <div class="information-wrapper">
            <div class="information-wrapper-title">
                <v-icon>mdi-information-outline</v-icon>
                <p class="information-wrapper-title-content">Information</p>
            </div>
            <div class="information-wrapper-text">
                <p class="information-wrapper-text-content" v-html="text"></p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            required: true,
        },
    },
};
</script>

<style></style>
